import React, { useState } from "react";
import { EmployerHeroSection } from "./EmployerHeroSection";
import { EmployerStatsSection } from "./EmployerStatsSection";
import { EmployerSolutionSection } from "./EmployerSolutionSection";
import { EmployerEmployeeExperienceSection } from "./EmployerEmployeeExperienceSection";
import { EmployerBenefitsSection } from "./EmployerBenefitsSection";
import { EmployerGetStartedSection } from "./EmployerGetStartedSection";
import { CalculatorModal } from "@/components/ui/CalculatorModal";
import { EmployerCalculator } from "./EmployerCalculator";

export const EmployersLayout: React.FC = () => {
  const [isCalcOpen, setIsCalcOpen] = useState(false);

  const handleCalcCta = () => {
    setIsCalcOpen(false);
    setTimeout(() => {
      document.getElementById("for-hr-benefit-leaders")?.scrollIntoView({ behavior: "smooth" });
    }, 300);
  };

  return (
    <>
      <EmployerHeroSection />
      <EmployerStatsSection onOpenCalc={() => setIsCalcOpen(true)} />
      <EmployerSolutionSection />
      <EmployerEmployeeExperienceSection />
      <EmployerBenefitsSection />
      <EmployerGetStartedSection />
      <CalculatorModal isOpen={isCalcOpen} onClose={() => setIsCalcOpen(false)}>
        <EmployerCalculator onCtaClick={handleCalcCta} />
      </CalculatorModal>
    </>
  );
};
